import { cx, LinariaClassName } from '@linaria/core';
import { Image } from 'components/Image/Image';
import { useState } from 'react';
import { genGradient } from 'components/EntityCard/utils';
import { cardContainer } from './Card.styles';

type Props = {
  icon?: React.ReactNode;
  imageUrl?: string;
  title: string | React.ReactNode;
  body: string | React.ReactNode;
  footer: string | React.ReactNode;
  badge?: string | React.ReactNode;
  badgeClassName?: string | LinariaClassName;
  cardClassName?: string;
};

export const Card: React.FC<Props> = ({ icon, imageUrl, title, body, footer, badge, badgeClassName, cardClassName }) => {
  const [hasImageError, setHasImageError] = useState(false);
  const hasValidImageSource = imageUrl && imageUrl?.trim() !== '';
  const fallbackBackground = imageUrl ? 'none' : genGradient((title as string) || 'fallback', 'diagonal');

  return (
    <div className={cx(cardContainer, cardClassName)}>
      <div className="card">
        {badge && <div className={cx('badge', badgeClassName)}>{badge}</div>}
        <div className="header">
          {icon ? (
            <div>{icon}</div>
          ) : hasValidImageSource && !hasImageError ? (
            <Image
              src={imageUrl}
              alt="Model display image"
              style={{ borderRadius: '2px' }}
              width={40}
              height={40}
              objectFit="contain"
              className="image"
              onError={() => setHasImageError(true)}
            />
          ) : (
            <div className="fallback" style={{ background: fallbackBackground }} />
          )}
          <h3 className="title" title={title as string}>
            {title}
          </h3>
        </div>
        <div className="body">{body}</div>
      </div>
      <div className="footer">{footer}</div>
    </div>
  );
};
